<template>
  <v-dialog
    content-class="dialog-custom"
    v-model="dialog"
    persistent
    width="450px"
  >
    <v-card light>
        <div style="position: absolute; right: 0; padding-top: 10px">
            <v-btn class="mx-2" icon title="Close Form" @click="handleDialogClose">
                <v-icon class="material-icons-round"> close </v-icon>
            </v-btn>
        </div>
       <div class="bankVerification">
            <ValidationObserver slim v-slot="{ invalid }">
                <div class="register__form">
                    <p class="register--title mb-0">Link your bank details</p>
                    <p class="register--subtitle">From which you will transact funds to invest.</p>
                    <div class="mb-30">
                        <ValidationProvider name="accountNo" vid = 'accountNo' rules="required" v-slot="{errors, classes }">
                            <div class="input-group" :class="classes">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <v-icon class="iconColor material-icons-round">account_balance</v-icon>
                                    </span>
                                </div>
                                <input type="number" class="form-control" v-model="accountNo" placeholder="Account Number">
                            </div>
                            <small class="form-group--error-message">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div class="mb-30">
                        <ValidationProvider name="Account" rules="required|confirmed:accountNo" v-slot="{errors, classes }">
                            <div class="input-group" :class="classes">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <v-icon class="iconColor material-icons-round">account_balance</v-icon>
                                    </span>
                                </div>
                                <input type="number" class="form-control" v-model="confirmAccountNo" placeholder="Confirm Account Number">
                            </div>
                            <small class="form-group--error-message">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div class="mb-10">
                        <ValidationProvider name="IFSC" rules="length:11|required|alpha_num" v-slot="{ errors, classes }">
                            <div class="input-group" :class="classes">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <img src ="/img/IFSC.svg">
                                    </span>
                                </div>
                                <input type="text" maxLength="11" class="form-control ifsc" v-model="ifsc" placeholder="HDFC00001">
                            </div>
                            <small class="form-group--error-message">{{ errors[0] }}</small>
                        </ValidationProvider>
                    </div>
                    <div style="display: flex; justify-content: center; align-items: center" class="register__form--referral-bottom">
                        <button class="btn_new btn-secondary-new mt-15 mb-15" @click="submitBankInfo" :disabled="invalid">Submit </button>
                    </div>
                </div>
            </ValidationObserver>
            <v-snackbar
                v-model="isFailure"
                app
                timeout="-1"
            >
                    {{failureText}}
                <template v-slot:action="{ attrs }">
                    <v-btn
                        color="red"
                        text
                        v-bind="attrs"
                        @click="isFailure = false"
                    >
                    Close
                    </v-btn>
                </template>
            </v-snackbar>
        </div>
    </v-card>
  </v-dialog>
</template>

<script>
import lenderService from '@/services/lenderService'
export default {
    name: 'editPhoneDialog',
    components: {
    },
    props: {
        showEditBankDialog: Boolean
    },
    data () {
        return {
            dialog: this.showEditBankDialog,
            accountNo: null,
            ifsc: null,
            consent: 'Y',
            isFailure: false,
            failureText: 'Something went wrong. Please try again!',
            confirmAccountNo: null
        }
    },
    methods: {
        handleDialogClose () {
            this.$emit('closeDialog')
        },
        submitBankInfo () {
            // call bank API
            this.$store.commit('isLoading')
            const payload = {
                bankAccountNumber: this.accountNo,
                ifsc: this.ifsc,
                consent: this.consent
            }
            lenderService.updateBankVerification(payload).then((res) => {
                this.$store.commit('isNotLoading')
                if (res.status === 200) {
                    this.success()
                } else if (res.status === 400) {
                    this.isFailure = true
                    this.failureText = 'Please recheck your Account Number and IFSC Code'
                } else if (res.status === 409) {
                    this.isFailure = true
                    this.failureText = 'This Bank Account has already been registered with us.'
                } else if (res.status === 410) {
                    this.isFailure = true
                    this.failureText = 'This account has already been closed'
                } else {
                    this.isFailure = true
                }
            })
        },
        success () {
            this.$store.dispatch('dashboard/setField', { field: 'bankAccountNumber', value: this.accountNo })
            this.$store.dispatch('dashboard/setField', { field: 'bankIfsc', value: this.ifsc })
            this.handleDialogClose()
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/sass/components/registration-flow.scss";
.v-card__title {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
  line-height: 24px;
  word-break: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bankVerification {
    padding: 24px;
}

    .ifsc {
        text-transform: uppercase;
    }
    ::placeholder {
        color: #e0e0e0
    }
    .iconColor {
        color: #9e9e9e
    }
</style>
